var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79646 0.204319C6.07989 0.482194 6.07989 0.943465 5.80201 1.2269L2.42862 4.61141H15.2831C15.6777 4.61141 16 4.93374 16 5.33388C16 5.73402 15.6777 6.05635 15.2831 6.05635H2.42862L5.80757 9.44086C6.08545 9.72429 6.07989 10.18 5.80201 10.4634C5.51858 10.7413 5.06843 10.7413 4.78499 10.4579L0.205627 5.84517C0.144495 5.77848 0.0944773 5.70623 0.0555749 5.61731C0.0166725 5.52839 0 5.43391 0 5.33944C0 5.15048 0.0722476 4.97264 0.205627 4.8337L4.78499 0.220992C5.05731 -0.0679974 5.51303 -0.073555 5.79646 0.204319Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlack);
export default __webpack_public_path__ + "static/media/arrow-left-black.9d818fbba5a22f253bec36deab681fa5.svg";
export { ForwardRef as ReactComponent };